import { Component } from '@angular/core';
import { environment } from '../../../environments/environment'
import { SharedDataService } from '../../helper/services/shared-data.service';
import { CommonModule } from '@angular/common';
import { CONSTANTS } from '../../helper/constants';
import { HelperService } from '../../helper/services/helper.service';
import { Router } from '@angular/router';
import { DialogService } from '../../helper/services/dialog.service';
import { CourseManagerService } from '../../networking/services/course-manager.service';

@Component({
    selector: 'app-bottom-bar',
    imports: [CommonModule],
    templateUrl: './bottom-bar.component.html',
    styleUrl: './bottom-bar.component.scss'
})
export class BottomBarComponent {
  version: string = environment.version
  constants = CONSTANTS

  constructor(
    public sharedDataService: SharedDataService, private helperService: HelperService, private router: Router, private dialogService: DialogService, private courseManagerService: CourseManagerService
  ){}

  openLoginDialog(): void {
    this.dialogService.openCourseManagerLoginDialog();
  }

  isLoggedIn(): boolean {
    return this.helperService.isLoggedIn();
  }

  logout() {
    this.courseManagerService.logoutUser()
  }
}
